import { Component, Input, OnInit } from '@angular/core';
import { Platform, ModalController } from '@ionic/angular';
import { GlobalMethodsService } from '../../../services/global-methods.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateConfigService } from 'src/app/services/commons/translate-config.service';
import { NpsService } from '../../../services/commons/nps.service';
import { Installation } from '../../../models/Installation';
import { ModalService } from 'src/app/services/commons/modal.service';

@Component({
  selector: 'app-nps',
  templateUrl: './nps.component.html',
  styleUrls: ['./nps.component.scss'],
})
export class NpsComponent implements OnInit {

  @Input('showModal') showModal: boolean;
  @Input('user') user: any;
  @Input('currentInstallation') currentInstallation: Installation;
  public npsForm: FormGroup;
  public isServiceBusy = false;
  public rating = 0;
  listThemes: string  [] = [];

  constructor(public platform: Platform,
    private formBuilder: FormBuilder,
    private modalCtrl: ModalController,
    private modalService: ModalService,
    public gms: GlobalMethodsService,
    private translate: TranslateConfigService,
    private npsService: NpsService) { }

  ngOnInit() {
    this.npsForm = this.formBuilder.group({
      themes: new FormControl('', [Validators.required]),
      comment: new FormControl('')
    });
    this.generateThemes();
    this.gms.analyticsTrackEvent('openScreen', { screenName: 'Danos tu opinion', contentGroup: 'Danos tu opinion' });
  }

  dismiss(value: boolean) {
    if(this.showModal){
      this.modalService.hide('npsModal', {value})
    }else{
      this.modalCtrl.dismiss({result: value}, '', 'npsModal');
    }
  }

  public async onSubmit() {
    if (this.isServiceBusy) {
      return;
    }
    if (this.npsForm.valid) {
      if(this.rating === 0){
        await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.errorRatingNps'),
        'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
      }else{
        const checkInternet = await this.gms.checkInternet();
        if (checkInternet) {
          this.gms.setLoadingTrue();
          this.isServiceBusy = true;
          const response = await this.npsService.sendNps(this.user.userName, this.currentInstallation.s_ins, 'SIC', this.rating,
            this.npsForm.value.themes, this.npsForm.value.comment);
          this.gms.setLoadingFalse();
          this.isServiceBusy = false;
          this.dismiss(response ? true : false);
          if(response){
            await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.nps.title'), await this.translate.getTranslate('MODAL.nps.descriptionOk'),
            'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
          }else{
            await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MODAL.nps.descriptionKo'),
            'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
          }
          this.gms.analyticsTrackEvent('add_nps', { eventCategory: 'SICOR/Añadir opinion de valoracion', eventAction: response ? 'Accion/Añadir opinion de valoracion' :  'Error/Añadir opinion de valoracion'});
        } else {
          await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
            'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
          this.dismiss(false);
        }
      }
    } else {
      this.validateAllFormFields(this.npsForm);
    }
  }

  isFieldValid(field: string) {
    return !this.npsForm.get(field).valid && this.npsForm.get(field).touched;
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (!control.valid) {
        this.gms.analyticsTrackEvent('form_error', { eventCategory: 'SICOR/Danos tu opinion', eventAction: 'Error/Form: Danos tu opinion', eventLabel: 'Campo: ' + field });
      }
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  async generateThemes(){
    const themes = await this.translate.getTranslate('NPS.themes') ;
    Object.keys(themes).map(key => this.listThemes.push(themes[key]));
  }

  changeRating(value: number){
    this.rating = value;
  }

}
